var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ACFBCD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#CFFFE3",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 26.1666C15.0473 26.1666 11.834 22.9533 11.834 18.9999C11.834 15.0466 15.0473 11.8333 19.0007 11.8333C22.954 11.8333 26.1673 15.0466 26.1673 18.9999C26.1673 22.9533 22.954 26.1666 19.0007 26.1666ZM19.0007 12.8333C15.6007 12.8333 12.834 15.5999 12.834 18.9999C12.834 22.3999 15.6007 25.1666 19.0007 25.1666C22.4007 25.1666 25.1673 22.3999 25.1673 18.9999C25.1673 15.5999 22.4007 12.8333 19.0007 12.8333Z",
    fill: "#009642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.053 21.3867C17.9196 21.3867 17.793 21.3334 17.6996 21.2401L15.813 19.3534C15.6196 19.1601 15.6196 18.8401 15.813 18.6467C16.0063 18.4534 16.3263 18.4534 16.5196 18.6467L18.053 20.1801L21.4796 16.7534C21.673 16.5601 21.993 16.5601 22.1863 16.7534C22.3796 16.9467 22.3796 17.2667 22.1863 17.4601L18.4063 21.2401C18.313 21.3334 18.1863 21.3867 18.053 21.3867Z",
    fill: "#009642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalApproveIcon);
export default __webpack_public_path__ + "static/media/modal-approve-icon.0159927d1a3eb1423a883abcf093107c.svg";
export { ForwardRef as ReactComponent };